import * as angular from 'angular';
import {IController} from 'angular';
import * as _ from "lodash";
import {AccountModel} from "../../angular/models/account.model";
import {$accountsFactory} from "../../$accounts.factory";
import {AccountsContextService} from "../../../commons/services/accounts-context.service";
import {SplitService} from "../../../commons/services/split-service.service";

export class AccountAutocompleteInputCtrl implements IController {

  account: AccountModel;
  accountId: string;
  searchQuery: string;
  label: any;
  allowClear: boolean;
  avoidIds: any;
  depotIds: any;
  noCache: any;
  isDemand: boolean;
  isBusiness: boolean;
  showImage?: boolean;
  showAddress?: boolean;
  showTags?: boolean;
  required: boolean;
  isDisabled: boolean;

  onSelect: Function;
  onClear: Function;

  public accountItem: AccountModel;
  private favouriteAccountId: any;
  private accountsRef = this.$accounts();

  constructor(private $accounts: $accountsFactory, private accountsContextService: AccountsContextService, private splitService: SplitService) {
  }

  $onInit() {
    if (!this.searchQuery) {
      this.searchQuery = null;
    }
    if (!this.label) {
      this.label = 'Search For Account';
    }
    if (!this.depotIds) {
      this.depotIds = [];
    }
    if (_.isUndefined(this.noCache)) {
      this.noCache = false;
    }

    this.favouriteAccountId = this.accountsContextService.getFavouriteAccountId(this.splitService.getSiteId());
  };

  $onChanges(changes) {
    if (changes.accountId) {
      var currentId = changes.accountId.currentValue,
          previousId = changes.accountId.previousValue;


      if (currentId && !_.isEqual(currentId, previousId)) {
        this.accountsRef.$asyncValues([currentId])
          .then((accounts) => {
            this.accountItem = accounts[0];
          })
      }
    }
    if (changes.account) {
      this.accountItem = angular.copy(this.account);
    }
  };

  searchChanged(searchQuery) {
    if (!searchQuery && _.isFunction(this.onClear)) {
      this.onClear();
    }
  }

  accountNameFilter(account: AccountModel) {
    return account.name;
  }

  onSearch(searchQuery) {

    const query = {
      isDemand: this.isDemand,
      isBusiness: this.isBusiness,
      depotIds: this.depotIds,
      limit: 10,
      descending: true,
      isActive: true,
      query: searchQuery,
    };

    return this.accountsRef.$getAll(query)
      .then((accountIds:string[]) => {
        if (this.avoidIds && !_.isEmpty(this.avoidIds)) {
          accountIds = _.filter(accountIds, (accountId) => {
            return _.indexOf(this.avoidIds, accountId) === -1
          })
        }
        return this.accountsRef.$asyncValues(accountIds)
      })
  }

  onSelectItem(item) {
    if (_.get(this.account, 'id') === item?.id || this.accountId === item?.id) {
      return;
    } else {
      if (this.allowClear) {
        this.searchQuery = null;
      }
      this.onSelect({account: item})
    }
  }

  onFavouriteAccountSelect(account?) {
    this.favouriteAccountId = account?.id;
  }


}

angular
  .module('bringoz.admin.accounts')
  .component('accountAutocompleteInput', {
    bindings: {
      account: '<?',
      accountId: '<?',
      searchQuery: '<?',
      label: '<?',
      allowClear: '<',
      avoidIds: '<?',
      depotIds: '<?',
      noCache: '<',
      isDemand: '<?',
      isBusiness: '<?',
      showImage: '<?',
      showAddress: '<?',
      showTags: '<?',
      onSelect: '&',
      onClear: '&?',
      required: '@?',
      isDisabled: '<?'
    },
    template: require('./account-autocomplete-input.html').default,
    controller: AccountAutocompleteInputCtrl
  });
